const ctx = () => new (window.AudioContext || (window as any).webkitAudioContext)();

let audioCtx: AudioContext | null = null;

function getCtx() {
  if (!audioCtx || audioCtx.state === "closed") {
    audioCtx = ctx();
  }
  if (audioCtx.state === "suspended") {
    audioCtx.resume();
  }
  return audioCtx;
}

function beep(frequency: number, duration: number, type: OscillatorType = "sine") {
  const ac = getCtx();
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0.3, ac.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.01, ac.currentTime + duration);
  osc.connect(gain);
  gain.connect(ac.destination);
  osc.onended = () => {
    osc.disconnect();
    gain.disconnect();
  };
  osc.start();
  osc.stop(ac.currentTime + duration);
}

export function playSuccess() {
  beep(880, 0.15);
  setTimeout(() => beep(1320, 0.2), 100);
}

export function playError() {
  beep(200, 0.2, "square");
  setTimeout(() => beep(150, 0.3, "square"), 150);
}

export function playDuplicate() {
  beep(520, 0.12);
}

export function playComplete() {
  beep(660, 0.1);
  setTimeout(() => beep(880, 0.1), 100);
  setTimeout(() => beep(1100, 0.15), 200);
  setTimeout(() => beep(1320, 0.25), 300);
}
